
export class Constantes {
  // public static readonly IPserver = 'http://admin.casaisiluminacion.com.ar';
  // public static readonly IPserver = 'http://192.168.0.8';
  
  public static readonly IPserver = 'https://fast-earth-15015.herokuapp.com';
    public static readonly Port = '';
    
  }